// src/routes/EcomOrderRoutes.jsx
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import PermissionRoute from './PermissionRoute';

// Order Components
import OrderListPage from '../pages/orders/OrderListPage';
import CreateOrderPage from '../pages/orders/CreateOrderPage';
import BulkOrderCreatePage from '../pages/orders/BulkOrderCreatePage';
import EditOrderPage from '../pages/orders/EditOrderPage';
import OrderDetailsPage from '../pages/orders/OrderDetailsPage';
import PhoneBlackList from '../pages/orders/PhoneBlackList';
import DeliveryFollowUpPage from '../pages/orders/DeliveryFollowUpPage';
import WoocommerceSyncPage from '../pages/orders/WoocommerceSyncPage';

const EcomOrderRoutes = () => {
  return (
    <Routes>
      {/* Order List */}
      <Route 
        path="/" 
        element={
          <PermissionRoute requiredPermission="view_all_ecom_orders">
            <OrderListPage />
          </PermissionRoute>
        } 
      />
      
      {/* Create Order */}
      <Route 
        path="/create" 
        element={
          <PermissionRoute requiredPermission="create_ecom_order">
            <CreateOrderPage />
          </PermissionRoute>
        } 
      />

      {/* Create Orders in Bulk */}
      <Route 
        path="/create-bulk" 
        element={
          <PermissionRoute requiredPermission="create_ecom_order">
            <BulkOrderCreatePage />
          </PermissionRoute>
        } 
      />
      
      {/* Edit Order */}
      <Route 
        path="/:orderId/edit" 
        element={
          <PermissionRoute requiredPermission="edit_ecom_order">
            <EditOrderPage />
          </PermissionRoute>
        } 
      />
      
      {/* Phone Blacklist */}
      <Route
        path="/phone-blacklist"
        element={
          <PermissionRoute requiredPermission="view_phone_blacklist">
            <PhoneBlackList />
          </PermissionRoute>
        }
      />

      {/* Delivery Follow-up */}
      <Route
        path="/delivery-follow-up"
        element={
          <PermissionRoute requiredPermission="view_all_ecom_orders">
            <DeliveryFollowUpPage />
          </PermissionRoute>
        }
      />

      {/* WooCommerce manual order sync */}
      <Route
        path="/woocommerce-sync"
        element={
          <PermissionRoute requiredPermission="sync_woocommerce_orders">
            <WoocommerceSyncPage />
          </PermissionRoute>
        }
      />

      {/* Order Details */}
      <Route
        path="/:orderId"
        element={
          <PermissionRoute requiredPermission="view_ecom_order">
            <OrderDetailsPage />
          </PermissionRoute>
        }
      />
    </Routes>
  );
};

export default EcomOrderRoutes;